import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { isGlobalChecklist, isLegacyChecklist } from '../checklists/utils';
import Icon from '../components/Icon';
import React, { useState } from 'react';

export function SelectGlobalChecklistPanel({
    visible,
    disabled,
    checklists,
    allGroups,
    selectedChecklistId,
    onSelect,
    onCreate,
}) {
    const [ title, setTitle ] = useState('');

    if (!visible) {
        return null;
    }

    const createChecklist = () => {
        const cleanTitle = title.trim();
        if (cleanTitle === '' || cleanTitle.length < 4) {
            return;
        }

        onCreate(cleanTitle);
    };

    const globalChecklists = checklists.filter(isGlobalChecklist);
    const legacyChecklists = checklists.filter(isLegacyChecklist);

    return (
        <>
            <h3>Global Checklists</h3>
            <InputGroup className="mb-2">
                <Input
                    type="select"
                    disabled={ disabled }
                    value={ selectedChecklistId || 0 }  // Use optional chaining and set default to 0
                    onChange={ e => {
                        const option = e.target.options[e.target.selectedIndex];
                        if (!option) {
                            return;
                        }

                        const foundChecklist = checklists.find(cl => cl.id === Number(e.target.value));
                        onSelect(foundChecklist ? foundChecklist.id : null);
                    } }
                >
                    <option
                        key={ 0 }
                        value={ 0 }
                    >Select an existing checklist
                    </option>
                    <optgroup label={ 'Global' }>
                        { globalChecklists.filter(isGlobalChecklist).map(cl =>
                            <option
                                key={ cl.id }
                                value={ cl.id }
                                data-group="global"
                            >{ cl.name }</option>,
                        ) }
                    </optgroup>
                    { allGroups.map(function (group) {
                        if (legacyChecklists.length < 1) {
                            // The component is rendering before the checklists completed fetching,
                            // so we can skip the logic.
                            return null;
                        }

                        const legacyBrandedChecklists = legacyChecklists.filter(otherLegacyChecklist => group.brandingIds.includes(otherLegacyChecklist.branding.id));
                        const legacyBrandedOptions = legacyBrandedChecklists.map(
                            function (bcl) {
                                return (
                                    <option
                                        key={ bcl.id }
                                        value={ bcl.id }
                                        data-group={ 'legacy' }
                                    >
                                        { bcl.name }
                                    </option>
                                );
                            },
                        );

                        return (
                            <optgroup
                                key={ group.id }
                                label={ group.name }
                            >
                                { legacyBrandedOptions }
                            </optgroup>
                        );
                    }) }
                </Input>
            </InputGroup>

            <InputGroup className="mb-2">
                <Input
                    disabled={ disabled }
                    value={ title }
                    onChange={ (e) => setTitle(e.target.value) }
                    placeholder={ 'Checklist title' }
                    style={ { flex: '0 1 30%' } }
                />
                <InputGroupAddon addonType="append">
                    <Button
                        disabled={ disabled }
                        color={ 'primary' }
                        onClick={ createChecklist }
                    >
                        <Icon icon="plus" /> Create New
                    </Button>
                </InputGroupAddon>
            </InputGroup>
        </>
    );
}
